import React from "react";
import CheckboxBase from "./Checkbox";
import { useFormContext } from "react-hook-form";

const CheckboxEditable = ({idx, ...props}) => {
    const {register} = useFormContext()
    return (
        <CheckboxBase value={idx} name="correct_answer" id={`answer-${idx}`} >
            <input {...register(`options[${idx}]`)} placeholder="Введите текст ответа" type="text" className={`border-none focus:border-none placeholder:text-lavender-60 py-0`} />
        </CheckboxBase>
    )
}

export default CheckboxEditable